interface WorkflowUpdateProps {
  update: string;
}

export const WorkflowUpdate = ({ update }: WorkflowUpdateProps) => (
  <div className="mt-4">
    <div className="flex items-center gap-2">
      <div className="w-2 h-2 sm:w-3 sm:h-3 bg-primary/20 rounded-full"></div>
      <h4 className="font-medium text-sm sm:text-base">Policy Overviews Live</h4>
    </div>
    <p className="text-neutral text-xs sm:text-sm mt-1">{update}</p>
  </div>
);